import { render } from "./SVGShelfForShelfRight.vue?vue&type=template&id=41a4bb04"
import script from "./SVGShelfForShelfRight.vue?vue&type=script&lang=js"
export * from "./SVGShelfForShelfRight.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__